import { render, staticRenderFns } from "./smartdemographicfield.vue?vue&type=template&id=37aec04a&scoped=true"
import script from "./smartdemographicfield.vue?vue&type=script&lang=js"
export * from "./smartdemographicfield.vue?vue&type=script&lang=js"
import style0 from "./smartdemographicfield.vue?vue&type=style&index=0&id=37aec04a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37aec04a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex})


/* vuetify-loader */
import installDirectives from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Intersect from 'vuetify/lib/directives/intersect'
installDirectives(component, {Intersect})
